export const subRoutesValues = [
  'consumption',
  'invoices',
  'reports',
  'own-information',
  'consumption-sites',
  'contact-us',
] as const;
export type SubRouteValue = typeof subRoutesValues[number];

export const subRoutes: { [key in string]: SubRouteValue } = {
  consumption: 'consumption',
  invoices: 'invoices',
  reports: 'reports',
  ownInformation: 'own-information',
  consumptionSites: 'consumption-sites',
  contactUs: 'contact-us',
};

export const routes = {
  index: '/',
  authorization: '/oauth/callback',
  accessibilityStatementEn: '/accessibility-statement/en',
  accessibilityStatementFi: '/accessibility-statement/fi',
  accessibilityStatementSv: '/accessibility-statement/sv',
};
